"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _Editor = _interopRequireDefault(require("./Editor"));

var _Loader = _interopRequireDefault(require("../Loader"));

var _redux = require("../../redux"); // import app components


var PrivateEditor = function PrivateEditor(props) {
  var postID = props.pageContext.databaseId,
      defaultComponent = props.defaultComponent;

  var _ref = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      post = _ref.cms.editor.post;

  var dispatch = (0, _redux.useAppDispatch)();
  var loaded = postID && (post === null || post === void 0 ? void 0 : post.id) === postID;
  (0, _react.useEffect)(function () {
    postID && _redux.postActions.getPost({
      id: postID
    });
    return function () {
      return dispatch((0, _redux.clearEditor)());
    };
  }, [postID]);

  if (!postID) {
    return defaultComponent;
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, loaded ? /*#__PURE__*/_react.default.createElement(_Editor.default, (0, _extends2.default)({
    postID: postID
  }, props)) : /*#__PURE__*/_react.default.createElement(_Loader.default, {
    text: "Load Post"
  }));
};

var _default = PrivateEditor;
exports.default = _default;